module.exports = __webpack_public_path__ + "static/img/Visualization25.e51bd08e.png";